import { gql } from '@apollo/client'

const profilePictureFragment = gql`
  fragment profilePicture on ImageAttachment {
    id
    cardUrl: url(format: { width: 265, height: 458, fit: crop })
    meanBackgroundColorHex
  }
`
export default profilePictureFragment
